import React, { useEffect, useState } from 'react';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Col, Form, Row } from 'antd';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { routerPath } from '../../router/routerPath';
import {
  BlueLayout,
  CustomButton,
  CustomGoBackButton,
  CustomInfoLayout,
  CustomMaskInput,
  FormContainer,
  FormInput,
  GridItem,
  PagesContainerUI,
  ValidatorFormItem,
} from '../../styles/styled';
import {
  addressRegExp,
  emailRegExp,
  phoneNumberRegExp,
  publisherTitleRegExp,
  websiteRegExp,
} from '../../utils/patterns';
import { PublisherType } from '../NewApplicationPage/types';
import { PublisherInputType } from './types';

export const NewPublisherPage = () => {
  const [publisherInputState, setPublisherInput] = useState<PublisherInputType>({});
  const [publisherChangesState, setPublisherChanges] = useState<PublisherInputType>({});
  const [isArchiveState, setIsArchive] = useState<boolean>(false);
  const [phoneNumbers, setPhoneNumbers] = useState<string[]>([]);
  const { id } = useParams();
  const navigate = useNavigate();

  const pushPublisher = async () => {
    if (
      !id &&
      publisherTitleRegExp.test(publisherInputState?.title || '') &&
      addressRegExp.test(publisherInputState?.address || '') &&
      emailRegExp.test(publisherInputState?.email || '') &&
      addressRegExp.test(publisherInputState?.law_address || '') &&
      websiteRegExp.test(publisherInputState?.web_site || '') &&
      phoneNumbers.length !== 0
    ) {
      try {
        const response = await api.post(endpoints.postPublisher(), {
          ...publisherInputState,
          phone: phoneNumbers.join('; '),
          is_archived: isArchiveState,
        });

        if (response) {
          navigate(routerPath.publisher);
        }
      } catch (err) {}
    } else if (
      id &&
      publisherTitleRegExp.test(publisherInputState?.title || '') &&
      addressRegExp.test(publisherInputState?.address || '') &&
      emailRegExp.test(publisherInputState?.email || '') &&
      addressRegExp.test(publisherInputState?.law_address || '') &&
      websiteRegExp.test(publisherInputState?.web_site || '') &&
      phoneNumbers.length !== 0
    ) {
      try {
        const response = await api.put(endpoints.putPublisherById(id), {
          ...publisherChangesState,
          phone: phoneNumbers.join('; '),
          is_archived: isArchiveState,
        });

        if (response) {
          navigate(routerPath.publisher);
        }
      } catch (err) {}
    }
  };

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const response = await api.get<PublisherType>(endpoints.getPublisherById(id));

          if (response.data.is_archived) setIsArchive(response.data.is_archived);

          if (response.data.phone) setPhoneNumbers(response.data.phone.split(';'));

          setPublisherInput(() => {
            return response.data;
          });
        } catch (err) {}
      })();
    }
  }, [id]);

  const deletePhoneFromPhonesArr = (id: number) => {
    if (phoneNumbers.length > 1) {
      setPhoneNumbers(phoneNumbers.filter((_, idx) => idx !== id));
    } else setPhoneNumbers([]);
  };

  return (
    <PagesContainerUI>
      <BlueLayout>
        <Link to={routerPath.publisher}>
          <CustomGoBackButton>{'<'}</CustomGoBackButton>
        </Link>
        Добавить издательство
      </BlueLayout>
      <Form
        onFinish={() => {
          pushPublisher();
        }}
      >
        <FormContainer padding="20px" background={'#fff'}>
          <Row gutter={[15, 15]}>
            <Col span={24}>
              <CustomInfoLayout color="dark" weight="normal" size="22px">
                Контактная информация
              </CustomInfoLayout>
            </Col>
            <Col span={24}>
              <ValidatorFormItem validator={!publisherTitleRegExp.test(publisherInputState?.title || '')} redstar>
                <div className="text">Наименование издательства</div>

                <FormInput
                  value={publisherInputState?.title}
                  onChange={(e) => {
                    setPublisherInput({ ...publisherInputState, title: e.target.value });
                    setPublisherChanges({ ...publisherChangesState, title: e.target.value });
                  }}
                />
              </ValidatorFormItem>
            </Col>
            <Col span={12}>
              <ValidatorFormItem
                overLength={publisherInputState?.law_address ? publisherInputState.law_address.length > 255 : false}
                validator={!addressRegExp.test(publisherInputState?.law_address || '')}
                redstar
              >
                <div className="text ">Юридический адрес</div>
                <FormInput
                  value={publisherInputState?.law_address}
                  onChange={(e) => {
                    setPublisherInput({ ...publisherInputState, law_address: e.target.value });
                    setPublisherChanges({ ...publisherChangesState, law_address: e.target.value });
                  }}
                />
              </ValidatorFormItem>
            </Col>
            <Col span={12}>
              <ValidatorFormItem
                overLength={publisherInputState?.address ? publisherInputState.address.length > 255 : false}
                validator={!addressRegExp.test(publisherInputState?.address || '')}
                redstar
              >
                <div style={{ display: 'flex', gap: '10px' }}>
                  <div className="text ">Фактический адрес</div>
                  <CustomButton
                    onClick={() => {
                      setPublisherInput({ ...publisherInputState, address: publisherInputState.law_address });
                      setPublisherChanges({ ...publisherChangesState, address: publisherInputState.law_address });
                    }}
                    padding="3px 10px"
                    fontsize="11px"
                    lowercase
                    type="button"
                    marginbottom="5px"
                  >
                    Заполнить как юр.адрес
                  </CustomButton>
                </div>
                <FormInput
                  value={publisherInputState?.address}
                  onChange={(e) => {
                    setPublisherInput({ ...publisherInputState, address: e.target.value });
                    setPublisherChanges({ ...publisherChangesState, address: e.target.value });
                  }}
                />
              </ValidatorFormItem>
            </Col>
            <Col span={12}>
              <ValidatorFormItem
                overLength={publisherInputState?.web_site ? publisherInputState.web_site.length > 255 : false}
                validator={!websiteRegExp.test(publisherInputState?.web_site || '')}
              >
                <div className="text ">Официальный сайт организации</div>
                <FormInput
                  value={publisherInputState?.web_site}
                  onChange={(e) => {
                    setPublisherInput({ ...publisherInputState, web_site: e.target.value });
                    setPublisherChanges({ ...publisherChangesState, web_site: e.target.value });
                  }}
                />
              </ValidatorFormItem>
            </Col>
            <Col span={12}>
              <ValidatorFormItem validator={!emailRegExp.test(publisherInputState?.email || '')} redstar>
                <div className="text">E-mail</div>
                <FormInput
                  value={publisherInputState?.email}
                  onChange={(e) => {
                    setPublisherInput({ ...publisherInputState, email: e.target.value });
                    setPublisherChanges({ ...publisherChangesState, email: e.target.value });
                  }}
                />
              </ValidatorFormItem>
            </Col>
            {phoneNumbers.length === 0 && (
              <Col span={12}>
                <ValidatorFormItem validator={!phoneNumberRegExp.test('7')} redstar>
                  <div className="text">Телефон</div>
                  <GridItem direction="row" gap="5px" justify="flex-start" wrap="nowrap">
                    <CustomMaskInput
                      mask="+7 (999) 999 - 99 - 99"
                      value={phoneNumbers.length > 0 ? phoneNumbers[0] : ''}
                      onChange={(e) => {
                        setPhoneNumbers([e.target.value]);
                      }}
                    />
                  </GridItem>
                </ValidatorFormItem>
              </Col>
            )}
            {phoneNumbers.map((el, idx) => {
              return (
                <Col span={12} key={idx}>
                  <ValidatorFormItem validator={!phoneNumberRegExp.test(phoneNumbers[idx])} redstar>
                    <div className="text">Телефон ({idx + 1})</div>
                    <GridItem direction="row" gap="5px" justify="flex-start" wrap="nowrap">
                      <CustomMaskInput
                        mask="+7 (999) 999 - 99 - 99"
                        value={phoneNumbers[idx]}
                        onChange={(e) => {
                          setPhoneNumbers(
                            phoneNumbers.map((phoneNumber, id) => (id === idx ? e.target.value : phoneNumber)),
                          );
                        }}
                      />

                      <CustomButton
                        type="button"
                        onClick={() => setPhoneNumbers([...phoneNumbers, ''])}
                        lined
                        padding="6px 10px"
                      >
                        <PlusOutlined />
                      </CustomButton>
                      <CustomButton
                        onClick={() => deletePhoneFromPhonesArr(idx)}
                        type="button"
                        error
                        lined
                        padding="6px 10px"
                      >
                        <DeleteOutlined />
                      </CustomButton>
                    </GridItem>
                  </ValidatorFormItem>
                </Col>
              );
            })}
            <Col span={24}>
              <GridItem align="center" justify="center" gap="20px" direction="row">
                <CustomButton type="submit">сохранить</CustomButton>
                <CustomButton width="300px" onClick={() => setIsArchive(!isArchiveState)} lined type="button">
                  {isArchiveState ? 'восстановление из архива' : 'перенос издательства в архив'}
                </CustomButton>
              </GridItem>
            </Col>
          </Row>
        </FormContainer>
      </Form>
    </PagesContainerUI>
  );
};
